import { SapBwLinkedService } from './../../linkedservice/sapbw.linkedservice';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapBwLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                server: '*',
                systemNumber: '*',
                clientId: '*',
                userName: '*',
                password: 'secret',
                encryptedCredential: '*'
            }
        }
    }
})
export class SapBwLinkedServiceAdapter extends LinkedServiceAdapter<SapBwLinkedService> {
    protected modelConstructor(): new () => SapBwLinkedService {
        return SapBwLinkedService;
    }

    protected model(): IModel {
        return SapBwLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: SapBwLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.SapBWLinkedService;

        properties.type = Metamodel.modelFor(SapBwLinkedService).name;
        properties.typeProperties = {
            server: linkedService.server,
            systemNumber: linkedService.systemNumber,
            clientId: linkedService.clientId,
            userName: linkedService.userName,
            password: passwordOrAKVtoSecretBase(linkedService.password, this.context)
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: SapBwLinkedService): Promise<SapBwLinkedService> {
        const prop = linkedServiceResource.properties as Model.SapBWLinkedService;
        linkedService.server = prop.typeProperties.server;
        linkedService.systemNumber = prop.typeProperties.systemNumber;
        linkedService.clientId = prop.typeProperties.clientId;
        linkedService.userName = prop.typeProperties.userName;
        linkedService.password = secretBaseToPasswordOrAKV(prop.typeProperties.password, true, this.context);

        return linkedService;
    }
}
